export enum OutbrainLoadingState {
  Pending = 'pending',
  Loading = 'loading',
  Loaded = 'loaded',
  Failed = 'failed',
}

export const HOME_SECTIONS = ['Lifestyle', 'Retail'];
